import React, { useState, useEffect } from "react";
import "../../styles/GuestLogin.css";
import { supabase } from "../../supabaseClient";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faTimes } from '@fortawesome/free-solid-svg-icons';
// import OnboardingModal from '../OnboardingModal/OnboardingModal';

export default function LoginPopup({
  onClose,
  initialSignup = false,
  initialReset = false,
  initialEmail = ""
}) {
  const [isSignup, setIsSignup] = useState(initialReset ? false : initialSignup);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });

  // FOR SPINNER DESIGN
  // const [isLoading, setIsLoading] = useState(false);

  // FOR HIDE AND SHOW PASSWORD
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // FORM STATES
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  
  const [signupName, setSignupName] = useState("");
  const [signupEmail, setSignupEmail] = useState("");
  const [signupPhone, setSignupPhone] = useState("");
  const [signupPassword, setSignupPassword] = useState("");
  const [signupConfirm, setSignupConfirm] = useState("");

  // FOR FORM ERRORS INPUT AND SUCCESS MESSAGE
  const [errors, setErrors] = useState([]);
  const [isSuccess, setIsSuccess] = useState(false);

  // FOR FORGOT PASSWORD
  const [isResetMode, setIsResetMode] = useState(initialReset);
  const [resetEmail, setResetEmail] = useState(initialEmail);

  const clearMessage = () => setMessage({ text: "", type: "" });

  // const [showOnboarding, setShowOnboarding] = useState(false);

useEffect(() => {
  setIsSignup(initialReset ? false : initialSignup);
  setIsResetMode(initialReset);
  setResetEmail(initialEmail || "");
  clearMessage();
}, [initialSignup, initialReset, initialEmail]);


// FOR LOGIN
const handleLogin = async (e) => {
  e.preventDefault();
  clearMessage();

  if (!loginEmail || !loginPassword) {
    setMessage({ text: "Please fill in all fields.", type: "error" });
    return;
  }

  setLoading(true);
  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email: loginEmail,
      password: loginPassword,
    });

    if (error) {
      setMessage({ text: error.message, type: "error" });
      return;
    }

    if (data?.user) {
      localStorage.setItem("justLoggedIn", Date.now());
      sessionStorage.removeItem("programPopupSeen"); // reset
      window.dispatchEvent(new StorageEvent("storage", {
      key: "justLoggedIn",
      newValue: Date.now()
    }));
  onClose();
}

  } catch (err) {
    setMessage({ text: "An unexpected error occurred.", type: "error" });
  } finally {
    setLoading(false);
  }
};

const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  return emailRegex.test(email.trim());
};

const isValidPHPhone = (phone) => {
  const cleaned = phone.replace(/\s|-/g, "");

  // Accepts:
  // 09171234567
  // +639171234567
  // 639171234567
  const phoneRegex = /^(09\d{9}|\+639\d{9}|639\d{9})$/;

  return phoneRegex.test(cleaned);
};
// FOR SIGNUP
const handleSignup = async (e) => {
  e.preventDefault();

  
  clearMessage();
  const newErrors = [];

  if (!signupName.trim()) newErrors.push("signupName");

if (!signupEmail.trim() || !isValidEmail(signupEmail)) {
  newErrors.push("signupEmail");
}

if (!signupPhone.trim() || !isValidPHPhone(signupPhone)) {
  newErrors.push("signupPhone");
}

if (signupPassword.length < 6) {
  newErrors.push("signupPassword");
}

if (signupPassword !== signupConfirm) {
  newErrors.push("signupConfirm");
}

  if (newErrors.length > 0) {
    setErrors(newErrors);
    setMessage({
      text: "Please enter a valid email and phone number.",
      type: "error",
    });
    return;
  }

  setLoading(true); // USE 'loading'
  try {
    const { data, error: authError } = await supabase.auth.signUp({
      email: signupEmail,
      password: signupPassword,
      options: { data: { full_name: signupName, phone: signupPhone } },
    });

    if (authError) throw authError;

    if (data?.user) {
      const { error: profileError } = await supabase
        .from('profiles')
        .upsert([{ 
          id: data.user.id, 
          full_name: signupName, 
          phone_number: signupPhone,
          email: signupEmail 
        }]);

      if (profileError) throw profileError;
      // await supabase.auth.signOut(); 
      setMessage({
        text: "Account created successfully!",
        type: "success",
      });

      setIsSuccess(true);
      setLoginEmail(signupEmail);
      setLoginPassword("");
    }
  } catch (error) {
    setMessage({ text: error.message, type: "error" });
  } finally {
    setLoading(false);
  }
};



// FOR FORGOT PASSWORD
  const handleForgotPassword = async () => {
    if (!resetEmail.trim()) {
      setErrors(["resetEmail"]);
      setMessage({ text: "Please enter your email.", type: "error" });
      return;
    }

    setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(resetEmail, {
      redirectTo: 'https://www.victoriasportsclub.com/forgotpassword', // Change this to your reset page URL
    });

    if (error) {
      setMessage({ text: error.message, type: "error" });
    } else {
      setMessage({ text: "If this email is registered, a reset link will arrive in your inbox shortly.", type: "success" });
      setResetEmail("");
      // Optionally stay on this screen or move back to login after a delay
    }
    setLoading(false);
  };


//FACEBOOK AS LOGIN
// const handleFacebookLogin = async () => {
//   const { error } = await supabase.auth.signInWithOAuth({
//     provider: "facebook",
//     options: {
//       redirectTo: window.location.origin,
//     },
//   });

//   if (error) {
//     console.error(error.message);
//   }
// };


  return (
    <div className="login-overlay">
      <div className={`login-container ${isSignup ? "signup-height" : ""}`}>
        <button className="login-close-btn" onClick={onClose} aria-label="Close"><FontAwesomeIcon icon={faTimes} /></button>
        
        <div className={`login-card ${isSignup ? "flipped" : ""}`}>
          
          {/* LOGIN SIDE */}
          <div className={`login-side ${!isSignup ? "visible" : ""}`}>
            <h2 className="login-title">
              {isResetMode ? "Reset Password" : "Welcome Back!"}
            </h2>
            
            {message.text && !isSignup && (
              <div className={`status-msg ${message.type}`}>{message.text}</div>
            )}


            {isResetMode ? (
              /* FORGOT PASSWORD VIEW */
              <>
                <p className="reset-desc">Enter your email and we'll send you a link to get back into your account.</p>
                <input
                  autoFocus
                  type="email"
                  placeholder="Email"
                  className={`login-input ${errors.includes("resetEmail") ? "input-error" : ""}`}
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                />
                <button className="login-primary-btn" onClick={handleForgotPassword} disabled={loading}>
                  {loading ? "Sending..." : "Send Reset Link"}
                </button>
                <div className="login-link" onClick={() => { setIsResetMode(false); clearMessage(); }}>
                  Back to Login
                </div>
              </>
            ) : (

            <form onSubmit={handleLogin}>
            <input
              autoFocus
              type="email"
              placeholder="Email"
              className="login-input"
              value={loginEmail}
              onChange={(e) => setLoginEmail(e.target.value)}
              disabled={loading}
            />
            
            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                className="login-input"
                value={loginPassword}
                onChange={(e) => setLoginPassword(e.target.value)}
                disabled={loading}
              />
             <button type="button" className="toggle-pass" onClick={() => setShowPassword(!showPassword)}>
                <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
              </button>
            </div>

           <button className="login-primary-btn" disabled={loading} onClick={handleLogin}>
              {loading ? (
                <>
                  <div className="button-loader"></div>
                  <span>Logging in...</span>
                </>
              ) : (
                "Login"
              )}
            </button>

            {/* <div className="social-divider">
              <span></span>
              <p>or continue with</p>
              <span></span>
            </div>

            <button
              type="button"
              onClick={handleFacebookLogin}
              className="facebook-login-btn"
              disabled={loading}
            >
              <span className="facebook-icon">f</span>
              Continue with Facebook
            </button> */}

            <div className="login-link" onClick={() => setIsResetMode(true)}>
              Forgot password?
            </div>

            <div className="login-dont-sign">
              <span className="login-dont-have">Don’t have an account?</span>
              <span className="login-link" onClick={() => { setIsSignup(true); clearMessage(); }}>Sign up</span>
            </div> 

            </form> 
            )} 

          </div>

          {/* SIGNUP SIDE */}
          <div className={`login-side login-back ${isSignup ? "visible" : ""}`}>
            
            {/* Move the Title outside the isSuccess check so it's always there */}
            <h2 className="login-title">
              {isSuccess ? "Welcome to the Club!" : "Create Account"}
            </h2>

            {isSuccess ? (
              /* SUCCESS VIEW - This now has top priority on the back side */
              <div className="success-container" style={{ textAlign: 'center', marginTop: '20px' }}>
                <div className="status-msg success">{message.text}</div>
                <p style={{ fontSize: '14px', color: '#555', margin: '20px 0' }}>
                  Your account is ready. Please log in with your credentials to explore Victoria Sports Club.
                </p>
                
                <button 
                  className="login-primary-btn" 
                  onClick={() => {
                    setIsSuccess(false); 
                    setIsSignup(false);  
                    clearMessage();      
                  }}
                >
                  Go to Login
                </button>
              </div>
            ) : (
              /* SIGNUP FORM VIEW */
              <form onSubmit={handleSignup}>
                {message.text && <div className={`status-msg ${message.type}`}>{message.text}</div>}

                <input
                  autoFocus
                  type="text"
                  placeholder="Full Name"
                  className={`login-input ${errors.includes("signupName") ? "input-error" : ""}`}
                  value={signupName}
                  onChange={(e) => {
                    setSignupName(e.target.value);
                    setErrors(errors.filter(err => err !== "signupName"));
                  }}
                  disabled={loading}
                />
                <input
                  type="email"
                  placeholder="Email"
                  className={`login-input ${errors.includes("signupEmail") ? "input-error" : ""}`}
                  value={signupEmail}
                  onChange={(e) => {
                    setSignupEmail(e.target.value);
                    setErrors(errors.filter(err => err !== "signupEmail"));
                  }}
                  disabled={loading}
                />
                <input
                  type="tel"
                  placeholder="Phone Number"
                  className={`login-input ${errors.includes("signupPhone") ? "input-error" : ""}`}
                  value={signupPhone}
                  onChange={(e) => {
                    setSignupPhone(e.target.value);
                    setErrors(errors.filter(err => err !== "signupPhone"));
                  }}
                  disabled={loading}
                />
                
                <div className="password-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    className={`login-input ${errors.includes("signupPassword") ? "input-error" : ""}`}
                    value={signupPassword}
                    onChange={(e) => {
                      setSignupPassword(e.target.value);
                      setErrors(errors.filter(err => err !== "signupPassword"));
                    }}
                    disabled={loading}
                  />
                  <button type="button" className="toggle-pass" onClick={() => setShowPassword(!showPassword)}>
                    <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                  </button>
                </div>

                <div className="password-wrapper">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm Password"
                    className={`login-input ${errors.includes("signupConfirm") ? "input-error" : ""}`}
                    value={signupConfirm}
                    onChange={(e) => {
                      setSignupConfirm(e.target.value);
                      setErrors(errors.filter(err => err !== "signupConfirm"));
                    }}
                    disabled={loading}
                  />
                  <button type="button" className="toggle-pass" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                    <FontAwesomeIcon icon={showConfirmPassword ? faEye : faEyeSlash} />
                  </button>
                </div>

               <button className="login-primary-btn" disabled={loading} onClick={handleSignup}>
                  {loading ? (
                    <>
                      <div className="button-loader"></div>
                      <span>Creating Account...</span>
                    </>
                  ) : (
                    "Sign Up"
                  )}
                </button>
                <div className="login-al-login">
                  <span className="login-al-ready">Already have an account?</span>
                  <span className="login-link" onClick={() => { setIsSignup(false); clearMessage(); }}>Login</span>
                </div> 
              </form>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}
